import React, { useCallback } from "react";
import { Alert } from "@ann/web-components";
import { SuggestionsContainer, ContentArea } from "./Suggestions.styled";
import { Filters, SuggestionsList } from "./components";
import { useSuggestions } from "./hooks";

const Suggestions = ({ onAddSuggestion: propOnAddSuggestion }) => {
  const {
    loading,
    suggestionGroups,
    filters,
    filterHandlers,
    filterUI,
    expandedGroups,
    handleToggleGroup,
    handleApprove,
    handleDecline,
    alert,
    handleCloseAlert,
  } = useSuggestions();


  return (
    <SuggestionsContainer>
      {alert && (
        <Alert
          title={alert.title}
          description={alert.description}
          severity={alert.severity}
          maxWidth="500px"
          closable={true}
          autoClose={true}
          autoCloseDelay={5000}
          onClose={handleCloseAlert}
        />
      )}
      <Filters
        loading={loading}
        filters={filters}
        filterHandlers={filterHandlers}
        filterUI={filterUI}
        onAddSuggestion={propOnAddSuggestion}
      />
      <ContentArea>
        <SuggestionsList
          groups={suggestionGroups}
          loading={loading}
          expandedGroups={expandedGroups}
          onToggleGroup={handleToggleGroup}
          onApprove={handleApprove}
          onDecline={handleDecline}
        />
      </ContentArea>
    </SuggestionsContainer>
  );
};

export default Suggestions;
